import { FC, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header/Header';
import './HomeLayout.scss';
import { Box } from '@mui/material';
import { TabPages } from '@components/commons';
import { FACILITY_TAB, TAB_OPTS, USER_ROLE } from '@utils/constants/enums';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { setFacilityTab } from '@redux/reducers/tabSlice';
import Footer from './Footer/Footer';
import { useAppSelector } from '@hooks';

const FacilityLayout: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tabValue = useSelector((state: RootState) => state.tab.facilityTab);
  const { user } = useAppSelector(state => state.auth);

  useEffect(() => {
    if (location.pathname.startsWith('/facility')) {
      dispatch(setFacilityTab(FACILITY_TAB.FACILITY));
    }
    if (location.pathname.startsWith('/account')) {
      dispatch(setFacilityTab(FACILITY_TAB.ACOUNT));
    }
  }, [location.pathname]);

  const handleChangeTab = (newValue: string) => {
    dispatch(setFacilityTab(newValue as FACILITY_TAB));
    navigate(`/${newValue}`);
  };

  return (
    <div className='HomeLayout'>
      <div className='HomeLayout__container'>
        <Header />
        <div className='FacilityLayoutBody'>
          <Box className='TabPagesWrapper'>
            {user.role !== USER_ROLE.RECEPTIONIST && (
              <TabPages
                value={tabValue}
                onChangeValue={(value: string) => handleChangeTab(value)}
                options={TAB_OPTS}
              />
            )}
          </Box>
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default FacilityLayout;
